import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CardLayerState, LayerFixResult } from '@/types/cardLayering';

interface CardLayeringState {
  currentIndex: number;
  cardStates: CardLayerState[];
  lastValidation: LayerFixResult | null;
  isDragging: boolean;
  draggingIndex: number | null;
  layeringEnabled: boolean;
}

const initialState: CardLayeringState = {
  currentIndex: 0,
  cardStates: [],
  lastValidation: null,
  isDragging: false,
  draggingIndex: null,
  layeringEnabled: true,
};

const cardLayeringSlice = createSlice({
  name: 'cardLayering',
  initialState,
  reducers: {
    updateCardStates: (state, action: PayloadAction<CardLayerState[]>) => {
      state.cardStates = action.payload;
    },
    
    setCurrentIndex: (state, action: PayloadAction<number>) => {
      state.currentIndex = action.payload;
    },
    
    setDragging: (state, action: PayloadAction<{ isDragging: boolean; cardIndex?: number }>) => {
      state.isDragging = action.payload.isDragging;
      state.draggingIndex = action.payload.isDragging ? action.payload.cardIndex || null : null;
    },
    
    updateValidation: (state, action: PayloadAction<LayerFixResult>) => {
      state.lastValidation = action.payload;
    },
    
    toggleLayering: (state) => {
      state.layeringEnabled = !state.layeringEnabled;
    },
    
    resetLayering: (state) => {
      state.currentIndex = 0;
      state.cardStates = [];
      state.lastValidation = null;
      state.isDragging = false;
      state.draggingIndex = null;
    },
    
    updateCardLayerState: (state, action: PayloadAction<{ cardIndex: number; layerState: CardLayerState }>) => {
      const { cardIndex, layerState } = action.payload;
      const existingIndex = state.cardStates.findIndex(card => card.cardIndex === cardIndex);
      
      if (existingIndex >= 0) {
        state.cardStates[existingIndex] = layerState;
      } else {
        state.cardStates.push(layerState);
      }
    },
  },
});

export const {
  updateCardStates,
  setCurrentIndex,
  setDragging,
  updateValidation,
  toggleLayering,
  resetLayering,
  updateCardLayerState,
} = cardLayeringSlice.actions;

export default cardLayeringSlice.reducer;